import React from 'react';
import "./photographers.css"
import photographer1 from "../../../Assets/photographer1.jpg"
import photographer2 from "../../../Assets/photographer2.jpg"
import photographer3 from "../../../Assets/photographer3.jpg"
import photographer4 from "../../../Assets/photographer4.jpg"
import photographer5 from "../../../Assets/photographer5.jpg"
import photographer6 from "../../../Assets/photographer6.jpg"

const Photographers = () => {
    return (
        <div>
        <div>
            <h1 className='text-center text-4xl font-bold mt-20 mb-10'>Photographers</h1>
        </div>
        <div className="flex flex-col items-center m-8">

<div className="w-full bg-white rounded overflow-x-hidden flex snap-x" style={{height:"70vh"}} >
<div className="snap-start w-full h-full flex items-center justify-center text-white text-4xl font-bold flex-shrink-0 bg-black relative" id="slide-1">
    <img src={photographer1} className="h-full w-full object-cover absolute inset-0 z-10 opacity-25"/>
    <h1 className="z-20 text-center">Photographer: Henry</h1>
  </div>
  <div className="snap-start w-full h-full flex items-center justify-center text-white text-4xl font-bold flex-shrink-0 bg-black relative" id="slide-2">
    <img src={photographer2} className="h-full w-full object-cover absolute inset-0 z-10 opacity-25"/>
    <h1 className="z-20 text-center">Photographer: Robert</h1>
  </div>
  <div className="snap-start w-full h-full flex items-center justify-center text-white text-4xl font-bold flex-shrink-0 bg-black relative" id="slide-3">
    <img src={photographer3} className="h-full w-full object-cover absolute inset-0 z-10 opacity-25"/>
    <h1 className="z-20 text-center">Photographer: Andrew</h1>
  </div>
  <div className="snap-start w-full h-full flex items-center justify-center text-white text-4xl font-bold flex-shrink-0 bg-black relative" id="slide-4">
    <img src={photographer4} className="h-full w-full object-cover absolute inset-0 z-10 opacity-25"/>
    <h1 className="z-20 text-center">Photographer: Klew</h1>
  </div>
  <div className="snap-start w-full h-full flex items-center justify-center text-white text-4xl font-bold flex-shrink-0 bg-black relative" id="slide-5">
    <img src={photographer5} className="h-full w-full object-cover absolute inset-0 z-10 opacity-25"/>
    <h1 className="z-20 text-center">Photographer: Hardin</h1>
  </div>
  <div className="snap-start w-full h-full flex items-center justify-center text-white text-4xl font-bold flex-shrink-0 bg-black relative" id="slide-6">
    <img src={photographer6} className="h-full w-full object-cover absolute inset-0 z-10 opacity-25"/>
    <h1 className="z-20 text-center">Photographer: Ronaldo</h1>
  </div>
</div>

<div className="flex mt-8">
  <a className="w-8 mr-1 h-8 text-gray-700 rounded-full bg-white flex justify-center items-center" href="#slide-1">1</a>
  <a className="w-8 mr-1 h-8 text-gray-700 rounded-full bg-white flex justify-center items-center" href="#slide-2">2</a>
  <a className="w-8 mr-1 h-8 text-gray-700 rounded-full bg-white flex justify-center items-center" href="#slide-3">3</a>
  <a className="w-8 mr-1 h-8 text-gray-700 rounded-full bg-white flex justify-center items-center" href="#slide-4">4</a>
  <a className="w-8 h-8 text-gray-700 rounded-full bg-white flex justify-center items-center" href="#slide-5">5</a>
  <a className="w-8 h-8 text-gray-700 rounded-full bg-white flex justify-center items-center" href="#slide-6">6</a>
</div>
</div>
        </div>
    );
};

export default Photographers;